import { EnquiriesTable } from "../components/enquiries-table/EnquiriesTable";


function Quotations() {

    return <EnquiriesTable />
}

export default Quotations;
